import "./App.css";
import ThreeExample from "./Three/threeExample";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <p>Experience the Cube</p>
        <ThreeExample />
      </header>
    </div>
  );
}

export default App;
